import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex justify-between items-center col-span-12" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col my-4 col-span-12"
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "my-4 col-span-12" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "my-4 col-span-12" }
const _hoisted_8 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submitInfo()), ["prevent"])),
      class: "grid grid-cols-12 gap-x-5 text-black",
      autocomplete: "off"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.info")), 1),
        (_ctx.role === 'TEACHER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.$t('labels.save'),
              type: "submit",
              class: "btn-primary p-button-sm",
              loading: _ctx.loading
            }, null, 8, ["label", "loading"]))
          : _createCommentVNode("", true)
      ]),
      (
          _ctx.infoData?.id == undefined && _ctx.predecessor && _ctx.objectiveClicked == null
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("objectives.inputs.predecessor")), 1),
            _createVNode(_component_AutoComplete, {
              id: "categories-input",
              optionLabel: "name",
              modelValue: _ctx.autocomplete.selected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autocomplete.selected) = $event)),
              suggestions: _ctx.autocomplete.sugestions,
              forceSelection: true,
              delay: 500,
              onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchForObjectives($event)))
            }, null, 8, ["modelValue", "suggestions"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("objectives.inputs.name")), 1),
        _createVNode(_component_InputText, {
          id: "title-input",
          type: "text",
          name: "name",
          modelValue: _ctx.infoData.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.infoData.name) = $event)),
          class: _normalizeClass(_ctx.v$.infoData.name.$error ? 'p-invalid' : ''),
          maxlength: 50,
          disabled: _ctx.role === 'ADMINISTRATOR'
        }, null, 8, ["modelValue", "class", "disabled"]),
        _createVNode(_component_Errors, {
          errors: _ctx.v$.infoData.name.$errors,
          actualLength: _ctx.infoData.name?.length,
          maxLength: 50
        }, null, 8, ["errors", "actualLength"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("objectives.inputs.description")), 1),
        _createVNode(_component_Textarea, {
          id: "description-input",
          autoResize: true,
          rows: "10",
          cols: "30",
          modelValue: _ctx.infoData.description,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.infoData.description) = $event)),
          class: _normalizeClass(_ctx.v$.infoData.description.$error ? 'p-invalid' : ''),
          maxlength: 999,
          disabled: _ctx.role === 'ADMINISTRATOR'
        }, null, 8, ["modelValue", "class", "disabled"]),
        _createVNode(_component_Errors, {
          errors: _ctx.v$.infoData.description.$errors,
          actualLength: _ctx.infoData.description?.length,
          maxLength: 999
        }, null, 8, ["errors", "actualLength"])
      ])
    ], 32)
  ]))
}